<template>
  <div class="container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item prop="search" label="机构名称">
              <el-input v-model.trim="queryForm.search" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch">
              搜索
            </el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table :data="orgList" v-loading="tableLoading" stripe border>
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          prop="orgName"
          label="机构名称"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column label="展示别名" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{ row.orgNickName || '--' }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" :resizable="false" width="100">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="修改" placement="top">
              <i class="iconfont iconcaozuo-1xiugai_1" @click="handleEdit(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.current"
        :page-size="queryForm.size"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <!-- 编辑对话框 -->
    <el-dialog
      title="编辑别名"
      width="700px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="cancelSubmit"
    >
      <el-form
        ref="paramsFormRef"
        :model="paramsForm"
        :rules="paramsFormRules"
        label-width="auto"
        label-suffix="："
      >
        <el-form-item label="机构名称" prop="orgName">
          <el-input v-model.trim="paramsForm.orgName" disabled></el-input>
        </el-form-item>
        <el-form-item label="展示别名" prop="orgNickName">
          <el-input v-model.trim="paramsForm.orgNickName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import orgApi from '@/api/home/org-mgr.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        search: '',
        current: 1,
        size: 10
      },
      orgList: [],
      tableLoading: false,
      dialogVisible: false,
      btnLoading: false,
      paramsForm: {
        orgId: '',
        orgName: '',
        orgNickName: ''
      },
      paramsFormRules: {
        // orgNickName: [{ required: true, message: '请输入展示别名', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.getOrgListData();
  },
  methods: {
    // 查询列表
    getOrgListData() {
      this.tableLoading = true;
      orgApi
        .getOrgList(this.queryForm)
        .then(({ data: res }) => {
          this.tableLoading = false;

          if (res.code !== 200) {
            return;
          }
          this.total = res.data.total;
          this.orgList = res.data.records;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.queryForm.size = 10;
      this.queryForm.current = 1;
      this.getOrgListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.size = 10;
      this.queryForm.current = 1;
      this.getOrgListData();
    },
    // 分页
    handleSizeChange(size) {
      this.queryForm.current = 1;
      this.queryForm.size = size;
      this.getOrgListData();
    },
    handleCurrentChange(current) {
      this.queryForm.current = current;
      this.getOrgListData();
    },
    // 点击编辑
    handleEdit(row) {
      this.paramsForm.orgId = row.orgId;
      this.paramsForm.orgName = row.orgName;
      this.paramsForm.orgNickName = row.orgNickName;
      this.dialogVisible = true;
    },
    // 取消编辑
    cancelSubmit() {
      this.dialogVisible = false;
      this.$refs.paramsFormRef.resetFields();
      this.paramsForm.orgId = '';
    },
    // 确定修改
    handleSubmit() {
      // console.log(this.paramsForm);
      this.btnLoading = true;
      orgApi
        .updateNickName(this.paramsForm)
        .then(({ data: res }) => {
          if (res.code === 200) {
            this.$message.success({
              message: '机构别名修改成功',
              type: 'success',
              duration: 1500
            });
            this.cancelSubmit();
            this.getOrgListData();
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  color: #333;
}
.container {
  padding: 16px;

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
